import { on } from 'delegated-events'

const fn = {
  init: () => {
    on('click', '.setup-options-trigger', fn.handleSetupOptions)

    fn.setupMapEmbed()
  },

  handleSetupOptions: (e) => {
    const trigger = e.target
    const lightGallery = window.lightGallery

    lightGallery(trigger, {
      dynamic: true,
      dynamicEl: JSON.parse(trigger.dataset.images),
      download: true,
      thumbnail: false,
    })
  },

  setupMapEmbed: () => {
    const mapHolder = document.getElementById('meeting-space-map')

    if (!mapHolder) {
      return
    }

    const google = window.google
    const data = JSON.parse(mapHolder.dataset.json)
    const center = new google.maps.LatLng(data.lat, data.lng)

    const mapOptions = {
      center,
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      scrollwheel: false,
      styles: [
        {
          featureType: 'poi',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
      ],
    }

    const map = new google.maps.Map(mapHolder, mapOptions)
    const bounds = new google.maps.LatLngBounds()

    google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
      const marker = new google.maps.Marker({
        map: map,
        title: data.title,
        animation: google.maps.Animation.DROP,
        position: new google.maps.LatLng(data.lat, data.lng),
        panposition: new google.maps.LatLng(data.lat, data.lng),
      })

      google.maps.event.addListener(marker, 'click', () => {
        window.open(data.mapLink)
      })

      bounds.extend(marker.getPosition())

      if (window.matchMedia('(min-width: 768px)').matches) {
        map.panBy(-100, 0)
      }
    })
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-meetingspacepage'),
  run: fn.init,
}
